import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "hetki-lang";
const DEFAULT_LANG = "fi";
const SUPPORTED = ["fi", "en"];

const LanguageContext = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) return stored;
    return DEFAULT_LANG;
  });

  const setLang = useCallback((next) => {
    if (!SUPPORTED.includes(next)) return;
    setLangState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (_) {}
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

/** Pick a localized value: usePick(t)({ fi: "...", en: "..." }) */
export const pick = (lang) => (entry) => {
  if (!entry) return "";
  if (typeof entry === "string") return entry;
  return entry[lang] ?? entry.fi ?? Object.values(entry)[0] ?? "";
};
